import gql from 'graphql-tag';

export const SaveApplicationBidMutation = gql`
         mutation($applicationBid: ApplicationBidInput!) {
           saveApplicationBid(applicationBid: $applicationBid) {
             id
             _Ebb_ApprovalTaskItemId
           }
         }
       `;

export const DeleteApplicationBidMutation = gql`
  mutation ($applicationBid: ApplicationBidInput!) {
    deleteApplicationBid (applicationBid: $applicationBid)
    {
      id
      _Ebb_ApplicationId
    }
  }
`;
